import {
  MY_PROGRESS_WORD_WALL_ITEM,
  REPORTS_MENU_ADMIN_STANDARDS_REPORT_ITEM,
  REPORTS_MENU_ADMIN_WRITING_REPORT_ITEM,
  REPORTS_MENU_CLASSROOM_DATA_ITEM,
  REPORTS_MENU_POWER_WORDS_ITEM,
  REPORTS_MENU_USAGE_REPORT_ITEM,
  V2_MY_PROGRESS_ITEM,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import useGetUserProperties from "@/users/v3/useGetUserProperties";

export const useGetReportsMenuSectionProps = () => {
  const {
    isStudent,
    canAdminViewUsageReport,
    canAdminViewStandardsReport,
    canAdminViewWritingReport,
  } = useGetUserProperties();
  const reportsMenuSectionTitle = isStudent ? "My progress" : "Reports";
  const reportsMenuSectionItems = [];

  if (isStudent) {
    reportsMenuSectionItems.push(V2_MY_PROGRESS_ITEM);
    reportsMenuSectionItems.push(MY_PROGRESS_WORD_WALL_ITEM);

    return {
      reportsMenuSectionTitle,
      reportsMenuSectionItems,
    };
  }

  // Classroom data
  reportsMenuSectionItems.push(REPORTS_MENU_CLASSROOM_DATA_ITEM);

  // Power words
  reportsMenuSectionItems.push(REPORTS_MENU_POWER_WORDS_ITEM);

  // Usage report
  if (canAdminViewUsageReport) {
    reportsMenuSectionItems.push(REPORTS_MENU_USAGE_REPORT_ITEM);
  }

  // Admin standards report
  if (canAdminViewStandardsReport) {
    reportsMenuSectionItems.push(REPORTS_MENU_ADMIN_STANDARDS_REPORT_ITEM);
  }

  // Writing report
  if (canAdminViewWritingReport) {
    reportsMenuSectionItems.push(REPORTS_MENU_ADMIN_WRITING_REPORT_ITEM);
  }

  return {
    reportsMenuSectionTitle,
    reportsMenuSectionItems,
  };
};
